(function() {

    "use strict";

    angular.module("apiManager", [
    ]);
})();